var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","outlined":"","color":"deep-orange","icon":"mdi-information"}},_vm._l((_vm.messages),function(message){return _c('ul',{key:message},[_c('li',[_vm._v(_vm._s(message))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }